<template>
  <span
    v-if="partyName"
    :class="party.class"
    class="party-label"
  >
    {{ text }}
  </span>
</template>

<script>
import PARTIES from "Constants/campaign/civicactioncenter/parties";

const parties = {
  [PARTIES.DEMOCRAT]: {
    class: "party-label--democratic",
    nameKey: "cac.app.democrat"
  },
  [PARTIES.REPUBLICAN]: {
    class: "party-label--republican",
    nameKey: "cac.app.republican"
  },
  other: {
    class: "party-label--other"
  }
};

export default {
  name: "PartyLabel",
  props: {
    partyName: {
      type: String,
      required: true
    }
  },
  computed: {
    party() {
      if (Object.keys(parties).includes(this.partyName)) {
        return parties[this.partyName];
      }
      return parties.other;
    },
    text() {
      if (this.party.nameKey) {
        return this.$t(this.party.nameKey);
      }
      return this.partyName;
    }
  }
};
</script>
